"use strict";

if (!customElements.get("promo-code-box")) {
  class PromoCodeBox extends HTMLElement {
    connectedCallback() {
      if (this.dataset.copyReady === "true") return;

      this.copyButton = this.querySelector("[data-copy-promo-code]");
      if (!this.copyButton) return;

      this.dataset.copyReady = "true";
      this.copyButton.addEventListener("click", () => this.copyCode());
    }

    async copyCode() {
      const code = this.dataset.promoCode;
      if (!code) return;

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(code);
        } else {
          this.copyWithFallback(code);
        }

        this.showCopiedState();
      } catch (error) {
        this.copyWithFallback(code);
        this.showCopiedState();
      }
    }

    copyWithFallback(code) {
      const textArea = document.createElement("textarea");
      textArea.value = code;
      textArea.setAttribute("readonly", "");
      textArea.style.position = "fixed";
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      textArea.remove();
    }

    showCopiedState() {
      window.clearTimeout(this.copyFeedbackTimer);
      this.copyButton.classList.add("is-copied");
      this.copyButton.setAttribute("title", "Копирано!");

      this.copyFeedbackTimer = window.setTimeout(() => {
        this.copyButton.classList.remove("is-copied");
        this.copyButton.setAttribute("title", "Копирай промокода");
      }, 1800);
    }
  }

  customElements.define("promo-code-box", PromoCodeBox);
}
